import AuthCertificateDetails from './AuthCertificateDetails';
import SubsidiariesList from './SubsidiariesList';
import React from 'react';

const NetsuiteIntegrationDetails = () => {
  return (
    <>
      <AuthCertificateDetails key="auth-certificate-details" />
      <SubsidiariesList key="subsidiaries-list" />
    </>
  );
};

export default NetsuiteIntegrationDetails;
